import {
  fetchShiftTypesStart,
  fetchShiftTypesSuccess,
  fetchShiftTypesFailure,
  createShiftType,
  updateShiftType,
  deleteShiftType,
} from '../slices/shiftTypesSlice';

import { db } from '../../firebase';
import { collection, getDocs, query, where } from 'firebase/firestore'; // Import necessary Firestore methods

export const fetchShiftTypes = () => async (dispatch, getState) => {
  try {
    dispatch(fetchShiftTypesStart());
    // Retrieve vid from local storage
    const { id: vid } = getState().currentUser.venue;

    // Retrieve vid from redux
    if (!vid) {
      throw new Error('Venue ID not found in storage');
    }

    // Firestore API call to get all shift types for the current venue
    const shiftTypesRef = collection(db, 'shiftTypes'); // Reference to the collection
    const q = query(shiftTypesRef, where('vid', '==', vid)); // Query shiftTypes where vid matches

    // Execute the query and get the documents
    const querySnapshot = await getDocs(q);
    const shiftTypesData = [];

    // // Extract the data from each document in the query result
    querySnapshot.forEach((doc) => {
      const shiftTypeData = doc.data();
      shiftTypesData.push({
        id: doc.id,
        ...shiftTypeData,
      });
    });

    // Dispatch the fetched shift types to the store
    dispatch(fetchShiftTypesSuccess(shiftTypesData));
  } catch (error) {
    console.error('Error fetching shift types:', error);
    dispatch(fetchShiftTypesFailure(error.message));
  }
};

export const createNewShiftType = (newShiftType) => async (dispatch) => {
  try {
    const response = await new Promise((resolve) =>
      setTimeout(() => {
        resolve({ ...newShiftType, id: Date.now().toString() });
      }, 500)
    );

    dispatch(createShiftType(response));
  } catch (error) {
    console.error('Error creating shift type:', error);
  }
};

export const updateExistingShiftType = (id, updatedShiftType) => async (dispatch) => {
  try {
    await new Promise((resolve) => setTimeout(resolve, 500));

    dispatch(updateShiftType({ id, updatedShiftType }));
  } catch (error) {
    console.error('Error updating shift type:', error);
  }
};

export const deleteExistingShiftType = (id) => async (dispatch) => {
  try {
    await new Promise((resolve) => setTimeout(resolve, 500));

    dispatch(deleteShiftType(id));
  } catch (error) {
    console.error('Error deleting shift type:', error);
  }
};
